module.exports = __webpack_public_path__ + "static/media/omdb-movies-nominations-desktop.2aa0abb2.jpg";